import { PaymentProviderType } from '../models';
// NOW ALSO USED FOR SMS! TODO: RENAME
export var EmailTemplateTypes;
(function (EmailTemplateTypes) {
    EmailTemplateTypes["LATE_FEE"] = "LATE_FEE";
    EmailTemplateTypes["REMINDER"] = "REMINDER";
    EmailTemplateTypes["AFTER_MARKED_PAID"] = "AFTER_MARKED_PAID";
    EmailTemplateTypes["DISCOUNT"] = "DISCOUNT";
    EmailTemplateTypes["LEGACY_LATE_FEE"] = "LEGACY_LATE_FEE";
    EmailTemplateTypes["STATEMENT_EMAIL"] = "STATEMENT_EMAIL";
    EmailTemplateTypes["STATEMENT_INTEREST_EMAIL"] = "STATEMENT_INTEREST_EMAIL";
    EmailTemplateTypes["SMS"] = "SMS";
    EmailTemplateTypes["QUOTE"] = "QUOTE";
    EmailTemplateTypes["PAYMENT_PLAN_REMINDER"] = "PAYMENT_PLAN_REMINDER";
    EmailTemplateTypes["ESCALATION"] = "ESCALATION";
    /** Used for invoice reference custom field in policy */
    EmailTemplateTypes["INVOICE_REFERENCE"] = "INVOICE_REFERENCE";
    EmailTemplateTypes["INVOICE_REFERENCE_STATEMENT_CHARGE"] = "INVOICE_REFERENCE_STATEMENT_CHARGE";
    /** Used for sending a generic announcement email template to one or more customers */
    EmailTemplateTypes["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    EmailTemplateTypes["CUSTOM_PAYMENT_LINK"] = "CUSTOM_PAYMENT_LINK";
})(EmailTemplateTypes || (EmailTemplateTypes = {}));
// TODO - Make customisable, but for now centralise the copy
export const PAYNOW_BUTTON_HTML = `<button
  style="background-color: #388E3C; color: white; padding: 8px 16px; border: none; border-radius: 4px; cursor: pointer;"
  aria-label="Pay Now"
  >
  Pay Now
  </button>`;
const directXeroLink = {
    name: 'Invoice Link (Xero)',
    value: 'InvoiceLink',
    isCurrency: false,
    sample: '<a href="https://example.com/invoice/INV-0001" target="_blank">View Invoice Online</a>',
    appliesToAccounting: [`XERO`],
};
const xeroInvoiceRef = {
    name: 'Invoice Reference',
    value: 'InvoiceReference',
    isCurrency: false,
    sample: 'Client P/Order #123',
    appliesToAccounting: [`XERO`],
};
const invoicePortalLink = {
    name: `Invoice Portal Link`,
    value: 'InvoicePortalLink',
    isCurrency: false,
    sample: 'https://my.paidnice.com/i/example',
    link: true,
};
const statementPortalLink = {
    name: `Online Statement Link`,
    value: 'StatementPortalLink',
    isCurrency: false,
    sample: 'https://my.paidnice.com/c/example',
    link: true,
};
const quotePortalLink = {
    name: `Online Quote Link`,
    value: 'QuotePortalLink',
    isCurrency: false,
    sample: 'https://my.paidnice.com/q/example',
    link: true,
};
/** New gen of payment links, only include the link itself, no copy */
const pinchPaymentLink = {
    name: `Pinch Payment Link`,
    value: 'PinchPaymentLink',
    isCurrency: false,
    sample: 'https://api.paidnice.com/proxy/org/123/inv/abc/pay?provider=PINCH',
    link: true,
    requiresPaymentProvider: PaymentProviderType.PINCH,
};
const customPaymentLink = {
    name: `Custom Payment Link`,
    value: 'CustomPaymentLink',
    isCurrency: false,
    sample: 'https://yourcustomlink.paidnice.com/org/123/inv/abc/pay?provider=CUSTOM',
    link: true,
    requiresPaymentProvider: PaymentProviderType.CUSTOM,
    new: true,
};
const rpsPaymentLink = {
    name: `RPS Payment Link`,
    value: 'RPSPaymentLink',
    isCurrency: false,
    sample: 'https://your-rps-url.com/org/123/inv/abc/pay',
    link: true,
    requiresPaymentProvider: PaymentProviderType.RPS,
    new: true,
};
const xeroInvoiceLink = {
    name: `Invoice Link (Xero)`,
    value: `XeroInvoiceLink`,
    isCurrency: false,
    sample: `https://example.com/invoice/INV-0001`,
    link: true,
    appliesToAccounting: [`XERO`],
};
const qboInvoiceLink = {
    name: `Invoice Link (QuickBooks)`,
    value: `QuickBooksInvoiceLink`,
    isCurrency: false,
    sample: `https://example.com/invoice/INV-0001`,
    link: true,
    appliesToAccounting: [`QBO`],
};
const pinchPaymentButton = {
    name: `Pinch Payment Link (Button)`,
    value: 'PinchPaymentButton',
    isCurrency: false,
    sample: `
    <a
      href="https://api.paidnice.com/proxy/org/123/inv/abc/pay?provider=PINCH"
      target="_blank"
      rel="noopener noreferrer"
    >
      ${PAYNOW_BUTTON_HTML}
    </a>
  `,
    requiresPaymentProvider: PaymentProviderType.PINCH,
    button: true,
};
// The sender profile's logo and signature, placed and aligned as blocks in the body
const senderBlocks = {
    Logo: {
        name: 'Sender Logo',
        value: 'Logo',
        isCurrency: false,
        block: true,
    },
    Signature: {
        name: 'Sender Signature',
        value: 'Signature',
        isCurrency: false,
        block: true,
    },
};
const contactPersonName = {
    name: 'Contact Person Name',
    value: 'ContactPersonName',
    isCurrency: false,
    sample: 'John Smith',
};
const contactPersonFirstName = {
    name: 'Contact Person First Name',
    value: 'ContactPersonFirstName',
    isCurrency: false,
    sample: 'John',
};
const invoiceContactName = {
    name: 'Invoice Contact Name',
    value: 'InvoiceContactName',
    isCurrency: false,
    sample: 'ABC Limited',
};
const quoteContactName = {
    name: 'Contact Name',
    value: 'ContactName',
    isCurrency: false,
    sample: 'ABC Limited',
};
const organisationContactNumber = {
    name: 'Organisation Contact Number',
    value: 'OrganisationContactNumber',
    isCurrency: false,
    sample: '+1 555 123 4567',
};
// The total number of unpaid invoices for the contact
const totalUnpaidInvoiceCount = {
    name: 'Total Unpaid Invoice Count (Statement)',
    value: 'TotalUnpaidInvoiceCount',
    isCurrency: false,
    sample: '5',
};
const totalOverdueInvoiceCount = {
    name: 'Total Overdue Invoice Count (Statement)',
    value: 'TotalOverdueInvoiceCount',
    isCurrency: false,
    sample: '2',
};
const overdueBalanceContact = {
    name: 'Overdue Balance (Statement)',
    value: 'OverdueBalance',
    isCurrency: true,
    sample: '$500.00',
};
const outstandingBalanceContact = {
    name: 'Outstanding Balance (Statement)',
    value: 'OutstandingBalance',
    isCurrency: true,
    sample: '$1000.00',
};
const overdueListAll = {
    name: 'All Overdue Invoices',
    value: 'OverdueListAll',
    isCurrency: false,
    sample: 'All overdue invoices: \n<br>INV-001 ($500.00)...',
    help: 'Lists all overdue invoices for the contact',
};
const overdueList30 = {
    name: 'Overdue Invoices (0-30 days)',
    value: 'OverdueList30',
    isCurrency: false,
    sample: 'Overdue invoices (0-30 days): \n<br>Invoice 001 balance: $500 due on 01 Jan 2025 ...',
    help: 'Lists overdue invoices up to 30 days overdue',
};
const overdueList60 = {
    name: 'Overdue Invoices (31-60 days)',
    value: 'OverdueList60',
    isCurrency: false,
    sample: 'Overdue invoices (31-60 days): \n<br>Invoice 001 balance: $500 due on 01 Jan 2025 ...',
    help: 'Lists overdue invoices between 31-60 days overdue',
};
const overdueList90 = {
    name: 'Overdue Invoices (61-90 days)',
    value: 'OverdueList90',
    isCurrency: false,
    sample: 'Overdue invoices (61-90 days): \n<br>Invoice 001 balance: $500 due on 01 Jan 2025 ...',
    help: 'Lists overdue invoices between 61-90 days overdue',
};
const overdueList90Plus = {
    name: 'Overdue Invoices (90+ days)',
    value: 'OverdueList90Plus',
    isCurrency: false,
    sample: 'Overdue invoices (90+ days): \n<br>Invoice 001 balance: $500 due on 01 Jan 2025 ...',
    help: 'Lists overdue invoices 90+ days overdue',
};
const outstandingButNotOverdue = {
    name: 'Outstanding But Not Overdue Invoices',
    value: 'OutstandingButNotOverdue',
    isCurrency: false,
    sample: 'Outstanding invoices: \n<br>Invoice 001 balance: $500 due on 01 Jan 2025 ...',
    help: 'Lists all unpaid invoices that are not yet overdue',
};
const dueThisMonthOrEarlierList = {
    name: 'Invoices Due This Month Or Earlier',
    value: 'DueThisMonthOrEarlierList',
    isCurrency: false,
    sample: 'Invoices due this month or earlier: \n<br>Invoice 001 balance: $500 due on 01 Jan 2025 ...',
    help: 'Lists all unpaid invoices with a due date in the current month or earlier',
    new: true,
};
const penaltiesSection = {
    name: `Upcoming Penalties Section`,
    value: `PenaltiesSection`,
    isCurrency: false,
    new: false,
    link: false,
};
const paymentPlanSection = {
    name: `Payment Plan Section`,
    value: `PaymentPlanSection`,
    isCurrency: false,
    new: true,
    link: false,
};
const balanceDueThisMonth = {
    name: `Balance Due This Month`,
    value: `BalanceDueThisMonth`,
    isCurrency: true,
    sample: `$500.00`,
    new: true,
};
const invoiceDate = {
    name: 'Invoice Date',
    value: 'InvoiceDate',
    isCurrency: false,
    sample: '01 May 2022',
};
const invoiceTotalAmount = {
    name: 'Invoice Total Amount',
    value: 'InvoiceTotalAmount',
    isCurrency: true,
    sample: '$500.00',
};
const invoiceTotalAmountNoCurrency = {
    name: 'Invoice Total Amount (No Currency)',
    value: 'InvoiceTotalAmountNoCurrency',
    isCurrency: false,
    sample: '500.00',
};
const reminderEmailBase = Object.assign(Object.assign({}, senderBlocks), { InvoiceContactName: invoiceContactName, ContactPersonName: contactPersonName, ContactPersonFirstName: contactPersonFirstName, OrganisationName: {
        name: 'Your Organisation Name',
        value: 'OrganisationName',
        isCurrency: false,
        sample: 'My Company Ltd',
    }, OrganisationContactNumber: organisationContactNumber, InvoiceLink: directXeroLink, InvoiceNumber: {
        name: 'Invoice Number',
        value: 'InvoiceNumber',
        isCurrency: false,
        sample: 'INV-0001',
    }, InvoiceReference: xeroInvoiceRef, DueDate: {
        name: 'Due Date',
        value: 'DueDate',
        isCurrency: false,
        sample: '14 May 2022',
    }, InvoiceDate: invoiceDate, CustomPaymentLink: customPaymentLink, RPSPaymentLink: rpsPaymentLink, PinchPaymentLink: pinchPaymentLink, PinchPaymentButton: pinchPaymentButton, InvoicePortalLink: invoicePortalLink, OutstandingBalance: Object.assign(Object.assign({}, outstandingBalanceContact), { new: true }), OverdueBalance: Object.assign(Object.assign({}, overdueBalanceContact), { new: true }), TotalUnpaidInvoiceCount: totalUnpaidInvoiceCount, TotalOverdueInvoiceCount: totalOverdueInvoiceCount, BalanceDueThisMonth: balanceDueThisMonth, DueThisMonthOrEarlierList: dueThisMonthOrEarlierList, XeroInvoiceLink: xeroInvoiceLink, QuickBooksInvoiceLink: qboInvoiceLink, StatementPortalLink: Object.assign(Object.assign({}, statementPortalLink), { new: true }), InvoiceTotalAmount: invoiceTotalAmount, InvoiceTotalAmountNoCurrency: invoiceTotalAmountNoCurrency });
export const mergeTags = {
    [EmailTemplateTypes.LEGACY_LATE_FEE]: {
        invoice_contact_name: {
            name: 'Invoice Contact Name',
            value: '{{{invoice_contact_name}}}',
            isCurrency: false,
            sample: 'John',
        },
        organisation_legal_name: {
            name: 'Your Organisation Name',
            value: '{{{organisation_legal_name}}}',
            isCurrency: false,
            sample: 'My Company Ltd',
        },
        invoice_public_url_original: {
            name: 'Original Invoice Link',
            value: '{{{invoice_public_url_original}}}',
            isCurrency: false,
            archived: true,
        },
        invoice_public_url_penalty: {
            name: 'Penalty Invoice Link',
            value: '{{{invoice_public_url_penalty}}}',
            isCurrency: false,
            archived: true,
        },
        penalty_amount: {
            name: 'Penalty Amount',
            value: '{{{penalty_amount}}}',
            isCurrency: true,
            sample: '$10.00',
        },
        original_invoice_number: {
            name: 'Original Invoice Number',
            value: '{{{original_invoice_number}}}',
            isCurrency: false,
            sample: 'INV-0001',
        },
        original_due_date: {
            name: 'Original Due Date',
            value: '{{{original_due_date}}}',
            isCurrency: false,
            sample: 'INV-0001',
        },
    },
    [EmailTemplateTypes.LATE_FEE]: Object.assign(Object.assign({}, senderBlocks), { InvoiceContactName: invoiceContactName, ContactPersonName: contactPersonName, ContactPersonFirstName: contactPersonFirstName, OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            isCurrency: false,
            sample: 'My Company Ltd',
        }, OrganisationContactNumber: organisationContactNumber, InvoiceLink: directXeroLink, PenaltyInvoiceLink: {
            name: 'Penalty Invoice Link',
            value: 'PenaltyInvoiceLink',
            isCurrency: false,
            sample: 'https://example.com/invoice/INV-0002',
            help: 'May be the same as the original invoice number if add to existing invoice is enabled',
            appliesToAccounting: [`XERO`],
        }, PenaltyAmount: {
            name: 'Penalty Amount',
            value: 'PenaltyAmount',
            isCurrency: true,
            sample: '$10.00',
        }, PenaltyInvoiceNumber: {
            name: 'Penalty Invoice Number',
            value: 'PenaltyInvoiceNumber',
            isCurrency: false,
            sample: 'INV-0002',
            help: 'May be the same as the original invoice number if add to existing invoice is enabled',
        }, OriginalInvoiceNumber: {
            name: 'Original Invoice Number',
            value: 'OriginalInvoiceNumber',
            isCurrency: false,
            sample: 'INV-0001',
        }, DueDate: {
            name: 'Due Date',
            value: 'DueDate',
            isCurrency: false,
            sample: '14 May 2022',
        }, InvoicePortalLink: invoicePortalLink, CustomPaymentLink: customPaymentLink, RPSPaymentLink: rpsPaymentLink, PinchPaymentLink: pinchPaymentLink, PinchPaymentButton: pinchPaymentButton, XeroInvoiceLink: xeroInvoiceLink, QuickBooksInvoiceLink: qboInvoiceLink }),
    [EmailTemplateTypes.REMINDER]: Object.assign(Object.assign({}, reminderEmailBase), { DaysUntilDue: {
            name: 'Days Until Due',
            value: 'DaysUntilDue',
            isCurrency: false,
            sample: '14',
        }, DaysAfterDue: {
            name: 'Days After Due',
            value: 'DaysAfterDue',
            isCurrency: false,
            sample: '14',
        }, DueAmount: {
            name: 'Due Amount',
            value: 'DueAmount',
            isCurrency: true,
            sample: '$250.00',
        }, DueAmountNoCurrency: {
            name: 'Due Amount (No Currency)',
            value: 'DueAmountNoCurrency',
            isCurrency: false,
            sample: '250.00',
        }, DiscountAmount: {
            name: 'Discount Amount',
            value: 'DiscountAmount',
            isCurrency: true,
            sample: '-$25.00',
        }, PenaltyForecastAmount: {
            name: 'Forecasted Penalty Amount',
            value: 'PenaltyForecastAmount',
            isCurrency: true,
            sample: '$10.00',
        }, PenaltiesSection: penaltiesSection, PaymentPlanSection: paymentPlanSection }),
    [EmailTemplateTypes.AFTER_MARKED_PAID]: Object.assign(Object.assign({}, reminderEmailBase), { MarkedPaidDate: {
            name: 'Marked Paid Date',
            value: 'MarkedPaidDate',
            isCurrency: false,
            sample: '14 May 2022',
        } }),
    [EmailTemplateTypes.SMS]: {
        InvoiceContactName: invoiceContactName,
        ContactPersonName: contactPersonName,
        ContactPersonFirstName: contactPersonFirstName,
        OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            isCurrency: false,
            sample: 'My Company Ltd',
        },
        OrganisationContactNumber: organisationContactNumber,
        InvoiceLink: {
            name: 'Invoice Link',
            value: 'InvoiceLink',
            isCurrency: false,
            sample: '<a href="https://example.com/invoice/INV-0001" target="_blank">View Invoice Online</a>',
            archived: true,
        },
        PenaltyForecastAmount: {
            name: 'Forecasted Penalty Amount',
            value: 'PenaltyForecastAmount',
            isCurrency: true,
            sample: '$10.00',
        },
        InvoiceNumber: {
            name: 'Invoice Number',
            value: 'InvoiceNumber',
            isCurrency: false,
            sample: 'INV-0001',
        },
        DueDate: {
            name: 'Due Date',
            value: 'DueDate',
            isCurrency: false,
            sample: '14 May 2022',
        },
        InvoiceDate: invoiceDate,
        DaysUntilDue: {
            name: 'Days Until Due',
            value: 'DaysUntilDue',
            isCurrency: false,
            sample: '14',
        },
        DaysAfterDue: {
            name: 'Days After Due',
            value: 'DaysAfterDue',
            isCurrency: false,
            sample: '14',
        },
        DueAmount: {
            name: 'Due Amount',
            value: 'DueAmount',
            isCurrency: true,
            sample: '$250.00',
        },
        CustomPaymentLink: customPaymentLink,
        RPSPaymentLink: rpsPaymentLink,
        PinchPaymentLink: pinchPaymentLink,
        InvoicePortalLink: Object.assign(Object.assign({}, invoicePortalLink), { sample: `https://portal.paidnice.com/i/example` }),
        XeroInvoiceLink: Object.assign(Object.assign({}, xeroInvoiceLink), { sample: `https://link.paidnice.com/abc123` }),
        QuickBooksInvoiceLink: Object.assign(Object.assign({}, qboInvoiceLink), { sample: `https://link.paidnice.com/abc123` }),
        PortalStatementLink: statementPortalLink,
        OutstandingBalance: outstandingBalanceContact,
        OverdueBalance: overdueBalanceContact,
    },
    [EmailTemplateTypes.DISCOUNT]: Object.assign(Object.assign({}, senderBlocks), { InvoiceContactName: invoiceContactName, ContactPersonName: contactPersonName, ContactPersonFirstName: contactPersonFirstName, OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            isCurrency: false,
            sample: 'My Company Ltd',
        }, OrganisationContactNumber: organisationContactNumber, InvoiceLink: directXeroLink, InvoiceNumber: {
            name: 'Invoice Number',
            value: 'InvoiceNumber',
            isCurrency: false,
            sample: 'INV-0001',
        }, DueDate: {
            name: 'Due Date',
            value: 'DueDate',
            isCurrency: false,
            sample: '14 May 2022',
        }, InvoiceDate: invoiceDate, DaysUntilDue: {
            name: 'Days Until Due',
            value: 'DaysUntilDue',
            isCurrency: false,
            sample: '14',
        }, DiscountRemoveDate: {
            name: 'Date when the discount will be removed',
            value: 'DiscountRemoveDate',
            isCurrency: false,
            sample: '14 May 2022',
        }, DiscountAmount: {
            name: 'Prompt payment discount amount',
            value: 'DiscountAmount',
            isCurrency: true,
            sample: '$100.00',
        }, OriginalTotal: {
            name: 'Original Invoice Total',
            value: 'OriginalTotal',
            isCurrency: true,
            sample: '$1,000.00',
        }, DiscountedTotal: {
            name: 'Total After Discount',
            value: 'DiscountedTotal',
            isCurrency: true,
            sample: '$900.00',
        }, InvoicePortalLink: invoicePortalLink, CustomPaymentLink: customPaymentLink, RPSPaymentLink: rpsPaymentLink, PinchPaymentLink: pinchPaymentLink, PinchPaymentButton: pinchPaymentButton, XeroInvoiceLink: xeroInvoiceLink, QuickBooksInvoiceLink: qboInvoiceLink }),
    [EmailTemplateTypes.STATEMENT_EMAIL]: Object.assign(Object.assign({}, senderBlocks), { ContactPersonName: contactPersonName, ContactPersonFirstName: contactPersonFirstName, ContactName: {
            name: 'Contact Name',
            value: 'ContactName',
            isCurrency: false,
            sample: 'ABC Limited',
        }, OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            isCurrency: false,
            sample: 'My Company Ltd',
        }, OrganisationContactNumber: organisationContactNumber, OutstandingBalance: outstandingBalanceContact, OverdueBalance: overdueBalanceContact, TotalUnpaidInvoiceCount: totalUnpaidInvoiceCount, TotalOverdueInvoiceCount: totalOverdueInvoiceCount, StatementDate: {
            name: 'Statement Date',
            value: 'StatementDate',
            isCurrency: false,
            sample: `1st November 23 - 30th November 23 OR 1st November 23`,
        }, OldestDueDate: {
            name: 'Oldest Due Date',
            value: 'OldestDueDate',
            isCurrency: false,
            sample: '14 May 2022',
            new: true,
        }, MostRecentDueDate: {
            name: 'Most Recent Due Date',
            value: 'MostRecentDueDate',
            isCurrency: false,
            sample: '14 May 2022',
            new: true,
        }, OverdueListAll: overdueListAll, OverdueList30: overdueList30, OverdueList60: overdueList60, OverdueList90: overdueList90, OverdueList90Plus: overdueList90Plus, OutstandingButNotOverdue: outstandingButNotOverdue, DueThisMonthOrEarlierList: dueThisMonthOrEarlierList, PortalStatementLink: statementPortalLink, BalanceDueThisMonth: balanceDueThisMonth }),
    [EmailTemplateTypes.STATEMENT_INTEREST_EMAIL]: Object.assign(Object.assign({}, senderBlocks), { ContactPersonName: contactPersonName, ContactPersonFirstName: contactPersonFirstName, ContactName: {
            name: 'Contact Name',
            value: 'ContactName',
            isCurrency: false,
            sample: 'ABC Limited',
        }, OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            isCurrency: false,
            sample: 'My Company Ltd',
        }, OrganisationContactNumber: organisationContactNumber, InterestAmount: {
            name: 'Interest Amount',
            value: 'InterestAmount',
            isCurrency: true,
            sample: '$10.00',
        }, NewOutstandingBalance: {
            name: 'New Outstanding Balance',
            value: 'NewOutstandingBalance',
            isCurrency: true,
            sample: '$10.00',
        }, NewOverdueBalance: {
            name: 'New Overdue Balance',
            value: 'NewOverdueBalance',
            isCurrency: true,
            sample: '$5.00',
        }, OriginalOverdueBalance: {
            name: 'Original Overdue Balance',
            value: 'OriginalOverdueBalance',
            isCurrency: true,
            sample: '$5.00',
        }, PortalStatementLink: statementPortalLink, InterestInvoiceLink: Object.assign(Object.assign({}, invoicePortalLink), { name: `Interest Invoice Link`, value: 'InterestInvoiceLink' }) }),
    [EmailTemplateTypes.ESCALATION]: {
        ContactName: {
            name: 'Contact Name',
            value: 'ContactName',
            isCurrency: false,
            sample: 'ABC Limited',
        },
        ContactPhone: {
            name: 'Contact Phone',
            value: 'ContactPhone',
            isCurrency: false,
            sample: '555-1234-7890',
        },
        ContactAddress: {
            name: 'Contact Address',
            value: 'ContactAddress',
            isCurrency: false,
            sample: '1223 North Street, New York, NY 10001',
        },
        OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            isCurrency: false,
            sample: 'My Company Ltd',
        },
        OrganisationContactNumber: organisationContactNumber,
        DueDate: {
            name: 'Due Date',
            value: 'DueDate',
            isCurrency: false,
            sample: '14 May 2022',
        },
        DueAmount: {
            name: 'Due Amount',
            value: 'DueAmount',
            isCurrency: true,
            sample: '$250.00',
        },
        InvoiceNumber: {
            name: 'Invoice Number',
            value: 'InvoiceNumber',
            isCurrency: false,
            sample: 'INV-0001',
        },
    },
    [EmailTemplateTypes.INVOICE_REFERENCE]: {
        InvoiceNumber: {
            name: 'Original Invoice Number',
            value: 'OriginalInvoiceNumber',
            isCurrency: false,
            sample: 'INV-0001',
        },
    },
    [EmailTemplateTypes.INVOICE_REFERENCE_STATEMENT_CHARGE]: {
        IssueDate: {
            name: `Interest Issue Date`,
            value: 'IssueDate',
            isCurrency: false,
            sample: '14 May 2022',
        },
    },
    [EmailTemplateTypes.ANNOUNCEMENT]: Object.assign(Object.assign({}, senderBlocks), { ContactPersonName: contactPersonName, ContactPersonFirstName: contactPersonFirstName, ContactName: {
            name: 'Contact Name',
            value: 'ContactName',
            isCurrency: false,
            sample: 'ABC Limited',
        }, OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            isCurrency: false,
            sample: 'My Company Ltd',
        }, OrganisationContactNumber: organisationContactNumber, PortalStatementLink: statementPortalLink }),
    [EmailTemplateTypes.QUOTE]: Object.assign(Object.assign({}, senderBlocks), { ContactName: quoteContactName, ContactPersonName: contactPersonName, ContactPersonFirstName: contactPersonFirstName, OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            isCurrency: false,
            sample: 'My Company Ltd',
        }, OrganisationContactNumber: organisationContactNumber, PortalStatementLink: statementPortalLink, QuotePortalLink: quotePortalLink, ExpiryDate: {
            name: 'Expiry Date',
            value: 'ExpiryDate',
            isCurrency: false,
            sample: '14 May 2022',
        }, IssueDate: {
            name: 'Issue Date',
            value: 'IssueDate',
            isCurrency: false,
            sample: '01 May 2022',
            new: true,
        }, QuoteNumber: {
            name: 'Quote Number',
            value: 'QuoteNumber',
            isCurrency: false,
            sample: 'QUO-0001',
        } }),
    [EmailTemplateTypes.CUSTOM_PAYMENT_LINK]: {
        ShortCode: {
            name: 'Short Code',
            value: 'ShortCode',
            isCurrency: false,
            appliesToAccounting: [`XERO`],
            sample: `gh67Jgv`,
        },
        QBOCompanyID: {
            name: 'QBO Company ID',
            value: 'QBOCompanyID',
            isCurrency: false,
            appliesToAccounting: [`QBO`],
            sample: `1234567890`,
        },
        InvoiceNumber: {
            name: 'Invoice Number',
            value: 'InvoiceNumber',
            isCurrency: false,
            sample: 'INV-0001',
        },
        InvoiceCurrency: {
            name: 'Invoice Currency',
            value: 'InvoiceCurrency',
            isCurrency: false,
            sample: 'USD',
        },
        DueAmount: {
            name: 'Due Amount',
            value: 'DueAmount',
            isCurrency: false,
            sample: '250.00',
        },
    },
    [EmailTemplateTypes.PAYMENT_PLAN_REMINDER]: Object.assign(Object.assign({}, senderBlocks), { InstalmentDueDate: {
            name: 'Installment Due Date',
            value: 'InstalmentDueDate',
            isCurrency: false,
            sample: '20 May 2026',
        }, InstalmentDueAmount: {
            name: 'Installment Due Amount',
            value: 'InstalmentDueAmount',
            isCurrency: true,
            sample: '$200.00',
        }, InstalmentPaidAmount: {
            name: 'Installment Paid Amount',
            value: 'InstalmentPaidAmount',
            isCurrency: true,
            sample: '$100.00',
        }, InstalmentTotalAmount: {
            name: 'Installment Total Amount',
            value: 'InstalmentTotalAmount',
            isCurrency: true,
            sample: '$300.00',
        }, InstalmentNumber: {
            name: 'Installment Number',
            value: 'InstalmentNumber',
            isCurrency: false,
            sample: '2',
        }, 
        // InstalmentDetails: {
        //   name: 'Installment Details',
        //   value: 'InstalmentDetails',
        //   sample: '<A breakdown of each installment will be displayed here>',
        // },
        InvoiceContactName: invoiceContactName, ContactPersonName: contactPersonName, ContactPersonFirstName: contactPersonFirstName, OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            isCurrency: false,
            sample: 'My Company Ltd',
        }, OrganisationContactNumber: organisationContactNumber, InvoiceLink: directXeroLink, InvoiceNumber: {
            name: 'Invoice Number',
            value: 'InvoiceNumber',
            isCurrency: false,
            sample: 'INV-0001',
        }, InvoiceReference: xeroInvoiceRef, InvoiceDueDate: {
            name: 'Due Date',
            value: 'InvoiceDueDate',
            isCurrency: false,
            sample: '14 May 2026',
        }, InvoiceDate: invoiceDate, InvoicePortalLink: invoicePortalLink, XeroInvoiceLink: xeroInvoiceLink, QuickBooksInvoiceLink: qboInvoiceLink, DueAmountNoCurrency: {
            name: 'Invoice Due Amount (No Currency)',
            value: 'DueAmountNoCurrency',
            isCurrency: false,
            sample: '250.00',
        }, DueAmount: {
            name: 'Invoice Due Amount',
            value: 'DueAmount',
            isCurrency: true,
            sample: '$250.00',
        }, InvoiceTotalAmount: invoiceTotalAmount, InvoiceTotalAmountNoCurrency: invoiceTotalAmountNoCurrency }),
};
//# sourceMappingURL=emailTemplateTypes.js.map